module.exports = __webpack_public_path__ + "media/app/images/trello-beb403b7dba1499ed142208877152dfd.png";